// eslint-disable-next-line import/no-extraneous-dependencies
import 'mediaelement'

class Audio {
  constructor(el) {
    this.DOM = {
      el,
    }
  }

  init() {
    this.DOM.el.forEach((el) => {
      // eslint-disable-next-line no-undef,no-unused-vars
      const player = new MediaElementPlayer(el, {
        defaultAudioWidth: 400,
        classPrefix: 'audioplayer__',
        setDimensions: false,
      })
    })
  }
}

export default Audio
